<template>
  <page>
    <v-card>
      <v-toolbar v-if="newMode" dense color="grey lighten-3" flat>
        <v-icon>mdi-plus</v-icon>
        <v-toolbar-title>Create New Renewal Messages</v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
        <v-icon>mdi-pencil</v-icon>
        <v-toolbar-title>Edit Renewal Messages</v-toolbar-title>
      </v-toolbar>
      <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Query Renewal Messages</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs12 md6 v-if="newMode">
              <v-text-field
                v-model="renMsgForm.clmNo"
                :label="labels.clmNo"
                :error-messages="errors.collect('clmNo')"
                data-vv-name="clmNo"
                :data-vv-as="labels.clmNo"
                v-validate="'max:12'"
                @change="doSetClmMaster"
              >
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer" v-if="newMode">
                  <v-icon color="info" @click="showClmHelpList = true" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6 v-else>
              <v-subheader class="queryLabel">{{ labels.clmNo }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.clmNo }}</div>
            </v-flex>
            <v-flex md6></v-flex>
            <v-flex xs12 md6 v-if="newMode">
              <v-text-field
                v-model="renMsgForm.polNo"
                :label="labels.polNo"
                :error-messages="errors.collect('polNo')"
                data-vv-name="polNo"
                :data-vv-as="labels.polNo"
                v-validate="'max:16'"
                :loading="loading"
                @change="doSetPolMaster"
              >
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer" v-if="newMode">
                  <v-icon color="info" @click="showPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6 v-else>
              <v-subheader class="queryLabel">{{ labels.polNo }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.polNo }}</div>
            </v-flex>
            <v-flex xs12 md6>
              <v-subheader class="queryLabel">{{ labels.renCnt }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.renCnt }}</div>
            </v-flex>
            <v-flex xs12 md6 v-if="newMode">
              <v-text-field
                v-model="renMsgForm.riskGrpNo"
                :label="labels.riskGrpNo"
                :error-messages="errors.collect('riskGrpNo')"
                data-vv-name="riskGrpNo"
                :data-vv-as="labels.riskGrpNo"
                :loading="loading"
              >
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer" v-if="newMode">
                  <v-icon color="info" @click="showPolRiskGrpHelpList = true" v-text="'mdi-magnify'"></v-icon> </v-slide-x-reverse-transition
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 v-else>
              <v-subheader class="queryLabel">{{ labels.riskGrpNo }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.riskGrpNo }}</div>
            </v-flex>
            <v-flex md6></v-flex>
            <v-flex xs12 md6 v-if="newMode">
              <v-text-field
                v-model="renMsgForm.riskNo"
                :label="labels.riskNo"
                :error-messages="errors.collect('riskNo')"
                data-vv-name="riskNo"
                :data-vv-as="labels.riskNo"
                :loading="loading"
              >
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer" v-if="newMode">
                  <v-icon color="info" @click="showPolRiskHelpList = true" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6 v-else>
              <v-subheader class="queryLabel">{{ labels.riskNo }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.riskNo }}</div>
            </v-flex>
            <v-flex md6></v-flex>
            <v-flex xs12 md6 v-if="newMode">
              <v-text-field
                v-model="renMsgForm.itemNo"
                :label="labels.itemNo"
                :error-messages="errors.collect('itemNo')"
                data-vv-name="itemNo"
                :data-vv-as="labels.itemNo"
                :loading="loading"
              >
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer" v-if="newMode">
                  <v-icon color="info" @click="showPolItemHelpList = true" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md6 v-else>
              <v-subheader class="queryLabel">{{ labels.itemNo }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.itemNo }}</div>
            </v-flex>
            <v-flex md6></v-flex>
            <v-flex xs12 md6>
              <v-subheader class="queryLabel">{{ labels.polStat }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.polStat }}</div>
            </v-flex>
            <v-flex xs12 md6>
              <v-subheader class="queryLabel">{{ labels.polStatDesc }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.polStatDesc }}</div>
            </v-flex>
            <v-flex xs12 md6>
              <v-subheader class="queryLabel">{{ labels.comDate }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.comDate }}</div>
            </v-flex>
            <v-flex xs12 md6>
              <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.expDate }}</div>
            </v-flex>
            <v-flex xs12 md6>
              <v-subheader class="queryLabel">{{ labels.insdName }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.insdName }}</div>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                :readonly="queryMode"
                v-model="renMsgForm.renMsg"
                :label="labels.renMsg"
                no-resize
                rows="4"
                :error-messages="errors.collect('renMsg')"
                data-vv-name="renMsg"
                :data-vv-as="labels.renMsg"
                :maxlength="4000"
                :loading="loading"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDateTime(renMsgForm.createdDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!newMode">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ renMsgForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDateTime(renMsgForm.modifiedDate) }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" :loading="submitting" @click="doCancel">
          <span>Cancel</span>
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" v-if="!queryMode" :loading="submitting" dark @click="doSave">
          Save
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showClmHelpList" width="1280px">
      <claim-help-list @close="showClmHelpList = false" @assign-claim-info="assignClaimNo"></claim-help-list>
    </v-dialog>

    <v-dialog v-model="showPolicyHelpList" width="1280px">
      <policy-help-list @close="showPolicyHelpList = false" @assign-policy-info="assignPolicy" polHeader="polHeader3"></policy-help-list>
    </v-dialog>

    <v-dialog v-model="showPolRiskGrpHelpList" width="1280px">
      <pol-risk-grp-help-list
        @close="showPolRiskGrpHelpList = false"
        @assign-polriskgrp="assignPolRiskGrp"
        :polNo="renMsgForm.polNo"
        :boolRefresh="showPolRiskGrpHelpList"
      ></pol-risk-grp-help-list>
    </v-dialog>

    <v-dialog v-model="showPolRiskHelpList" width="1280px">
      <pol-risk-help-list
        @close="showPolRiskHelpList = false"
        @assign-polrisk="assignPolRisk"
        :polNo="renMsgForm.polNo"
        :riskGrpNo="renMsgForm.riskGrpNo"
        :boolRefresh="showPolRiskHelpList"
      ></pol-risk-help-list>
    </v-dialog>

    <v-dialog v-model="showPolItemHelpList" width="1280px">
      <pol-item-help-list
        @close="showPolItemHelpList = false"
        @assign-politem="assignPolItem"
        :polNo="renMsgForm.polNo"
        :riskGrpNo="renMsgForm.riskGrpNo"
        :riskNo="renMsgForm.riskNo"
        :boolRefresh="showPolItemHelpList"
      ></pol-item-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime } from '@/utils/date'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import PolicyHelpList from '@/components/core/common/dialog/PolicyHelpList'
import PolRiskGrpHelpList from '@/components/core/common/dialog/PolRiskGrpHelpList'
import PolRiskHelpList from '@/components/core/common/dialog/PolRiskHelpList'
import PolItemHelpList from '@/components/core/common/dialog/PolItemHelpList'

export default {
  data() {
    return {
      labels: {
        clmNo: 'Claim No.',
        polNo: 'Policy No.',
        renCnt: 'Renewal Count',
        riskGrpNo: 'Risk Group No.',
        riskNo: 'Risk No.',
        itemNo: 'Item No.',
        polStat: 'Policy Status',
        polStatDesc: 'Policy Status Description',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        insdName: 'Insured Name',
        renMsg: 'Renewal Message',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      renMsgForm: {
        clmNo: null,
        polNo: null,
        renCnt: null,
        riskGrpNo: null,
        riskNo: null,
        itemNo: null,
        polStat: null,
        polStatDesc: null,
        comDate: null,
        expDate: null,
        insdName: null,
        renMsg: null,
        createdBy: null,
        createdDate: null
      },
      newMode: true,
      reviewMode: false,
      queryMode: false,
      showClmHelpList: false,
      showPolicyHelpList: false,
      showPolRiskGrpHelpList: false,
      showPolRiskHelpList: false,
      showPolItemHelpList: false,
      loading: false,
      submitting: false
    }
  },
  mounted() {
    if (this.renMsgMode === 'Review') {
      this.newMode = false
      this.reviewMode = true
      this.queryMode = false
    } else if (this.renMsgMode === 'Query') {
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
    } else if (this.renMsgMode === 'New') {
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
    }
    this.doInit()
  },
  methods: {
    async doInit() {
      if (!this.newMode) {
        this.fetchData()
      } else {
        var formData = {
          createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
          createdDate: new Date(),
          modifiedBy: null,
          modifiedDate: null,
          clmNo: ''
        }
        this.renMsgForm = formData
      }
    },
    async fetchData() {
      this.resetValidator()
      this.resetMessages()
      const apiURI = this.menu.getRenMsg
      if (apiURI) {
        this.loading = true
        const expand = {
          polNo: this.$route.params.renMsgData.polNo,
          renCnt: this.$route.params.renMsgData.renCnt,
          clmNo: this.$route.params.renMsgData.clmNo
        }
        await this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.renMsgForm.polNo = data.renMsg.polNo
              this.renMsgForm.renCnt = data.renMsg.renCnt
              this.renMsgForm.clmNo = data.renMsg.clmNo
              this.renMsgForm.riskGrpNo = data.renMsg.riskGrpNo
              this.renMsgForm.riskNo = data.renMsg.riskNo
              this.renMsgForm.itemNo = data.renMsg.itemNo
              this.renMsgForm.polStat = data.renMsg.polStat
              this.renMsgForm.polStatDesc = data.renMsg.polStatDesc
              this.renMsgForm.comDate = formatDisplayDate(data.renMsg.comDate)
              this.renMsgForm.expDate = formatDisplayDate(data.renMsg.expDate)
              this.renMsgForm.insdName = data.renMsg.insdName
              this.renMsgForm.renMsg = data.renMsg.renMsg
              this.renMsgForm.createdBy = data.createdBy
              this.renMsgForm.createdDate = data.createdDate
              this.renMsgForm.modifiedBy = data.modifiedBy
              this.renMsgForm.modifiedDate = data.modifiedDate
            }
            this.loading = false
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    assignClaimNo(data) {
      this.renMsgForm.clmNo = data.clmNo
      this.renMsgForm.polNo = data.polNo
      this.renMsgForm.renCnt = data.renCnt
      this.showClmHelpList = false
    },
    assignPolicy(data) {
      this.renMsgForm.polNo = data.polNo
      this.renMsgForm.renCnt = data.renCnt
      this.renMsgForm.polStat = data.polStat
      this.renMsgForm.polStatDesc = data.polStatDesc
      this.renMsgForm.comDate = formatDisplayDate(data.comDate)
      this.renMsgForm.expDate = formatDisplayDate(data.expDate)
      this.renMsgForm.insdName = data.insdName1
      this.renMsgForm.riskGrpNo = 1
      this.renMsgForm.riskNo = 1
      this.renMsgForm.itemNo = 1
      this.showPolicyHelpList = false
    },
    assignPolRiskGrp(riskGrpNo) {
      this.renMsgForm.riskGrpNo = riskGrpNo
    },
    assignPolRisk(riskNo) {
      this.renMsgForm.riskNo = riskNo
    },
    assignPolItem(itemNo) {
      this.renMsgForm.itemNo = itemNo
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createRenMsg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.renMsgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'clmRenMsg' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateRenMsg
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.renMsgForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'clmRenMsg' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'clmRenMsg' })
    },
    doSetClmMaster() {
      if (this.renMsgForm.clmNo === undefined || this.renMsgForm.clmNo === null || this.renMsgForm.clmNo === '') {
        this.renMsgForm.polNo = null
        this.renMsgForm.renCnt = null
        this.renMsgForm.riskGrpNo = null
        this.renMsgForm.riskNo = null
      }
    },
    doSetPolMaster() {
      if (this.renMsgForm.polNo === null || this.renMsgForm.polNo === undefined || this.renMsgForm.polNo === '') {
        this.renMsgForm.renCnt = null
        this.renMsgForm.polStat = null
        this.renMsgForm.comDate = null
        this.renMsgForm.expDate = null
        this.renMsgForm.insdName = null
        this.renMsgForm.riskGrpNo = null
        this.renMsgForm.riskNo = null
        this.renMsgForm.itemNo = null
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    }
  },
  computed: {
    menu() {
      return this.$store.state.claims.renewalMessage.menu
    },
    renMsgMode() {
      return this.$route.params.renMsgMode
    }
  },
  components: {
    ClaimHelpList,
    PolicyHelpList,
    PolRiskGrpHelpList,
    PolRiskHelpList,
    PolItemHelpList
  },
  mixins: [MessageMixin]
}
</script>
